import { Component, Input, OnInit } from '@angular/core';

@Component({
   selector: 'samweb-icon-with-subicon',
   templateUrl: './icon-with-subicon.component.html',
   styleUrls: ['./icon-with-subicon.component.scss'],
})
export class IconWithSubiconComponent implements OnInit {
   @Input()
   public primaryIcon;
   @Input()
   public secondaryIcon;

   constructor() {}

   ngOnInit(): void {}
}
